import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt';
import { useUserMerchantAccessPermission } from 'pages/Users/hooks/useUserMerchantAccessPermission';
import { FieldProps, useRecordContext } from 'react-admin';
import { ArrayChipField } from 'shared/react-admin/Fields';
import { User } from 'types/embedded/user';

type Props = Pick<FieldProps<User>, 'label' | 'source' | 'sortable'>;

export const UsersListMerchantAccessField: React.FC<Props> = () => {
  const record = useRecordContext<User>();
  const isUserMerchantAccessAvailable = useUserMerchantAccessPermission(record?.rolesValues);

  if (!isUserMerchantAccessAvailable) {
    return <DoNotDisturbAltIcon sx={{ color: 'error.light', width: '20px' }} />;
  }

  return <ArrayChipField collapseToOne optionText="merchant.name" source="merchantAccesses" />;
};
